const { DateTime } = require("luxon");

const fbTsToDate = (firebase, fbObj) => {
  if (!fbObj) return null;

  if (fbObj instanceof Date) return fbObj;

  if (fbObj.toDate && typeof fbObj.toDate === "function") return fbObj.toDate();

  if (typeof fbObj === "string") {
    return DateTime.fromISO(fbObj).toJSDate();
  }

  if (!fbObj.seconds && !fbObj.nanoseconds) return null;

  return new firebase.firestore.Timestamp(
    fbObj.seconds,
    fbObj.nanoseconds
  ).toDate();
};

module.exports = {
  fbTsToDate,
};
